import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';

export const createOnTimeZoneChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onTimeZoneChange']
> =
  ({ setState }) =>
  async (timeZoneId) => {
    setState({ selectedTimezone: timeZoneId });
  };
